export enum ReportType {
    ProjectStatus = 1,
    Budget = 2,
    Maar = 3,
    ProgressStatus = 4,
    Site = 5,
    AppealRecommendation = 6,
    ReturnScheduleSummary = 7,
    ReturnAssetDetail = 8,
    UserActivity = 9,
    BudgetVariance = 10,
    UserAccess = 11,
    CsrCommandCenter = 12,
    UserCSR = 13,
    AppealList = 14,
    SupportInstanceEscalationActivity = 15,
    InitialValue = 17,
    FinalValue = 18,
    ARBValue = 19,
    ARBCoverLetter = 20,
    TaxSavings = 21,
    AttachmentBundlerCompany = 1001, // UI-internal only; renumbered from 20 to avoid conflict with ARBCoverLetter = 20
    AttachmentBundlerJurisdiction = 1002, // UI-internal only; renumbered from 21
}
